/* Toni Pons PDP — exact variant selection + availability sync */
(function () {
  'use strict';

  var FORM_SELECTOR = '.tp-pdp__form';
  var OPTION_SELECTOR = '[data-option-input]';
  var ROOT_SELECTOR = 'section.tp-pdp[id^="tp-product-"]';

  function isArabic() {
    return document.documentElement.dir === 'rtl' ||
      /^ar(?:-|$)/i.test(document.documentElement.lang || '');
  }

  function soldOutLabel() {
    return isArabic() ? 'نفد من المخزون' : 'Sold out';
  }

  function fallbackAddLabel() {
    return isArabic() ? 'أضيفي إلى السلة' : 'Add to cart';
  }

  function getRoot(form) {
    return form.closest(ROOT_SELECTOR) || form.closest('.tp-pdp') || form.parentElement;
  }

  function getVariants(form) {
    var root = getRoot(form);
    if (!root) return [];
    if (Array.isArray(root._tpExactVariants)) return root._tpExactVariants;

    var script = root.querySelector('[data-tp-variants]');
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent || '[]');
      root._tpExactVariants = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      root._tpExactVariants = [];
    }

    return root._tpExactVariants;
  }

  function getGroups(form) {
    var root = getRoot(form);
    return Array.from((root || form).querySelectorAll('[data-option-group]')).sort(function (a, b) {
      var ai = a.querySelector(OPTION_SELECTOR);
      var bi = b.querySelector(OPTION_SELECTOR);
      return Number(ai && ai.dataset.optionPosition || 0) - Number(bi && bi.dataset.optionPosition || 0);
    });
  }

  function getSelectedValues(form) {
    return getGroups(form).map(function (group) {
      var checked = group.querySelector(OPTION_SELECTOR + ':checked');
      return checked ? checked.value : '';
    });
  }

  function snapshotSelection(form) {
    return getGroups(form).map(function (group) {
      var checked = group.querySelector(OPTION_SELECTOR + ':checked');
      return {
        position: checked ? String(checked.dataset.optionPosition || '') : '',
        value: checked ? checked.value : ''
      };
    });
  }

  function restoreSelection(form, snapshot) {
    if (!snapshot || !snapshot.length) return;
    var inputs = Array.from((getRoot(form) || form).querySelectorAll(OPTION_SELECTOR));

    snapshot.forEach(function (choice) {
      if (!choice.position) return;

      inputs.forEach(function (input) {
        if (String(input.dataset.optionPosition || '') === choice.position) {
          input.checked = input.value === choice.value;
        }
      });
    });
  }

  function findExactVariant(form) {
    var variants = getVariants(form);
    var selected = getSelectedValues(form);

    if (!selected.length) {
      var variantInput = form.querySelector('[data-variant-id], input[name="id"]');
      var currentId = variantInput ? String(variantInput.value || '') : '';

      return variants.find(function (variant) {
        return String(variant.id) === currentId;
      }) || variants[0] || null;
    }

    if (selected.some(function (value) { return !value; })) return null;

    return variants.find(function (variant) {
      return Array.isArray(variant.options) &&
        variant.options.length === selected.length &&
        variant.options.every(function (value, index) {
          return String(value) === String(selected[index]);
        });
    }) || null;
  }

  function rememberAddLabel(form, button, label) {
    if (form.dataset.tpExactAddLabel) return;

    var current = label ? (label.textContent || '').trim() : '';

    if (button && !button.disabled && current && current !== soldOutLabel()) {
      form.dataset.tpExactAddLabel = current;
    } else {
      form.dataset.tpExactAddLabel = fallbackAddLabel();
    }
  }

  function formatPrice(cents) {
    var amount = Number(cents || 0) / 100;
    var text = Number.isInteger(amount)
      ? String(amount)
      : amount.toFixed(2).replace(/\.?0+$/, '');

    return text + ' ⃁';
  }

  function syncSelectedOptionLabels(form) {
    var root = getRoot(form);
    if (!root) return;

    getGroups(form).forEach(function (group) {
      var checked = group.querySelector(OPTION_SELECTOR + ':checked');
      if (!checked) return;

      var position = checked.dataset.optionPosition || group.dataset.optionPosition;
      if (!position) return;

      var selectedLabel = root.querySelector('[data-selected-option="' + position + '"]');
      if (selectedLabel) {
        selectedLabel.textContent = checked.value;
      }
    });
  }

  function syncVariantPresentation(form, variant) {
    if (!variant) return;

    var root = getRoot(form);
    if (!root) return;

    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');
    var discount = root.querySelector('[data-discount]');
    var sku = root.querySelector('[data-sku]');
    var skuWrap = root.querySelector('[data-sku-wrap]');

    var variantPrice = Number(variant.price || 0);
    var comparePrice = Number(variant.compare_at_price || 0);
    var onSale = comparePrice > variantPrice && comparePrice > 0;

    if (price) {
      price.textContent = formatPrice(variantPrice);
      price.classList.toggle('is-sale', onSale);
    }

    if (compare) {
      compare.textContent = onSale ? formatPrice(comparePrice) : '';
      compare.classList.toggle('is-hidden', !onSale);
    }

    if (discount) {
      var percent = onSale
        ? Math.round(((comparePrice - variantPrice) * 100) / comparePrice)
        : 0;

      discount.textContent = onSale ? '-' + percent + '%' : '';
      discount.classList.toggle('is-hidden', !onSale);
    }

    if (sku) {
      sku.textContent = variant.sku || '';
    }

    if (skuWrap) {
      skuWrap.classList.toggle('is-hidden', !variant.sku);
    }

    /* Keep the browser URL aligned with the actual selected Shopify variant. */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      /* URL sync is non-critical. */
    }
  }

  function sync(form) {
    if (!form || !form.matches(FORM_SELECTOR)) {
      return { variant: null, available: null, authoritative: false };
    }

    var variants = getVariants(form);

    /* Fail open: never disable the product if variant data is missing. */
    if (!variants.length) {
      syncSelectedOptionLabels(form);
      return { variant: null, available: null, authoritative: false };
    }

    var button = form.querySelector('[data-add], button[name="add"]');
    var label = button && (button.querySelector('[data-add-label]') || button.querySelector('span'));
    var variantInput = form.querySelector('[data-variant-id], input[name="id"]');
    var variant = findExactVariant(form);
    var available = !!(variant && variant.available);

    syncSelectedOptionLabels(form);

    if (button) {
      rememberAddLabel(form, button, label);
    }

    if (variantInput && variant) {
      var previousId = String(variantInput.value || '');

      variantInput.value = variant.id;
      variantInput.setAttribute('value', variant.id);

      if (previousId !== String(variant.id)) {
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (variant) {
      syncVariantPresentation(form, variant);
    }

    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
      button.dataset.tpVariantAvailable = available ? 'true' : 'false';
    }

    if (label) {
      label.textContent = available
        ? (form.dataset.tpExactAddLabel || fallbackAddLabel())
        : soldOutLabel();
    }

    form.dataset.tpVariantAvailable = available ? 'true' : 'false';

    if (variant) {
      form.dataset.tpVariantId = String(variant.id);

      var root = getRoot(form);
      if (root) {
        root.dispatchEvent(new CustomEvent('tp:variant:change', {
          bubbles: true,
          detail: { variant: variant }
        }));
      }
    }

    return {
      variant: variant,
      available: available,
      authoritative: true
    };
  }

  function enforceAfterOtherVariantScripts(form, snapshot) {
    Promise.resolve().then(function () {
      restoreSelection(form, snapshot);
      sync(form);
    });

    requestAnimationFrame(function () {
      restoreSelection(form, snapshot);
      sync(form);
    });

    setTimeout(function () {
      restoreSelection(form, snapshot);
      sync(form);
    }, 0);
  }

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest
      ? event.target.closest(OPTION_SELECTOR)
      : null;

    if (!input) return;

    var form = input.closest(FORM_SELECTOR);
    if (!form) return;

    var snapshot = snapshotSelection(form);

    sync(form);
    enforceAfterOtherVariantScripts(form, snapshot);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target &&
      event.target.matches &&
      event.target.matches(FORM_SELECTOR)
      ? event.target
      : null;

    if (!form) return;

    var state = sync(form);

    if (state.authoritative && (!state.variant || !state.available)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function init() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      sync(form);
    });
  }

  window.ToniPonsVariantAvailability = {
    sync: sync,
    findExactVariant: findExactVariant
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();